/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";

import _ from "lodash";
import {
  Alert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Chip as MuiChip,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Add as AddIcon, Download } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { makeStyles, withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import { CSVLink } from "react-csv";
import swal from "sweetalert";
import moment from "moment";
import GlobalInventoryFilter from "./GlobalInventoryFilter";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const useStyles = makeStyles({
  tableCell: {
    padding: "0px 12px 0px 0px",
    width: "1000px",
  },
});

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(
  id,
  height,
  width,
  thickness,
  company,
  quantity,
  brand,
  technology,
  hsn,
  size,
  deleted
) {
  return {
    id,
    height,
    width,
    thickness,
    company,
    quantity,
    brand,
    technology,
    hsn,
    size,
    deleted,
  };
}

const headCells = [
  { key: "size", alignment: "left", label: "Size" },
  { key: "company", alignment: "left", label: "Company" },
  { key: "quantity", alignment: "left", label: "Quantity" },
  { key: "brand", alignment: "left", label: "Brand" },
  { key: "technology", alignment: "left", label: "Technology" },
  { key: "hsn", alignment: "left", label: "HSN" },
];

const EnhancedTableHead = (props) => {
  const { viewPermission, editPermission } = props;

  const [head, setHeads] = useState(headCells);
  useEffect(() => {
    if (viewPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "view", alignment: "center", label: "View" },
      ]);
    }
    if (editPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "edit", alignment: "center", label: "Edit" },
      ]);
    }
  }, [viewPermission, editPermission]);

  return (
    <TableHead>
      <TableRow>
        {head.map((headCell) => (
          <TableCell
            // style={{ width: 100 }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  const {
    rows,
    setFilter,
    height,
    width,
    thickness,
    setHeight,
    setWidth,
    setThicknesss,
    searchKeyword,
    setSearchKeyWord,
    onSearch,
    setOnSearch,
    csvPermission,
  } = props;
  const navigate = useNavigate();

  let timestamp = moment().format("DD-MM-YY HH:mm");

  const csvReport = {
    filename: `Global_Inventory_Plates_${timestamp}.csv`,
    headers: headCells,
    data: rows,
  };
  return (
    <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
      <Typography variant="h6" id="tableTitle">
        Global Inventory
      </Typography>

      <div style={{ display: "flex", alignItems: "center" }}>
        {csvPermission && (
          <CSVLink
            style={{ color: "green", textDecoration: "none" }}
            {...csvReport}
          >
            <Button
              variant="outlined"
              sx={{ ml: 2, mr: 2 }}
              endIcon={<Download />}
            >
              CSV
            </Button>
          </CSVLink>
        )}
        <TextField
          size="small"
          label={"Search Plates"}
          value={searchKeyword}
          sx={{ margin: "0 10px", width: "300px" }}
          placeholder={"Search by brand, tech and company"}
          onChange={(e) => {
            setSearchKeyWord(e.target.value);
          }}
        />

        <Button
          endIcon={<SearchIcon />}
          variant="contained"
          type="submit"
          sx={{ mr: 2 }}
          onClick={() => setOnSearch(true)}
        >
          Search
        </Button>

        <div>
          {/* <Filter /> */}
          <GlobalInventoryFilter
            setFilter={setFilter}
            height={height}
            width={width}
            thickness={thickness}
            setHeight={setHeight}
            setWidth={setWidth}
            setThicknesss={setThicknesss}
          />
        </div>
        <div>
          <Tooltip title="Add Plate">
            <IconButton aria-label="Add Plate" size="large">
              <AddIcon
                onClick={() => navigate("/dashboard/inventory/plates")}
              />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </Toolbar>
  );
};

function EnhancedTable({
  rows,
  editPermission,
  viewPermission,
  total,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  filter,
  setFilter,
  height,
  width,
  thickness,
  setHeight,
  setWidth,
  setThicknesss,
  searchKeyword,
  setSearchKeyWord,
  onSearch,
  setOnSearch,
  csvPermission,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);

  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert mt={2} mb={4} severity="success">
          {message}
        </Alert>
      </Snackbar>
      <Paper>
        <EnhancedTableToolbar
          rows={rows}
          numSelected={selected.length}
          setFilter={setFilter}
          height={height}
          width={width}
          thickness={thickness}
          setHeight={setHeight}
          setWidth={setWidth}
          setThicknesss={setThicknesss}
          searchKeyword={searchKeyword}
          setSearchKeyWord={setSearchKeyWord}
          onSearch={onSearch}
          setOnSearch={setOnSearch}
          csvPermission={csvPermission}
        />
        {rows.length === 0 ? (
          <Box
            sx={{
              height: "calc(100vh - 266px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5">No Plates available</Typography>
          </Box>
        ) : (
          <>
            <StyledTableContainer>
              <Table
                aria-labelledby="tableTitle"
                size={"small"}
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                  viewPermission={viewPermission}
                  editPermission={editPermission}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                      <TableRow
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={`${row.id}-${index}`}
                        selected={isItemSelected}
                        style={{
                          backgroundColor: row.deleted && "#F799A6",
                        }}
                      >
                        <TableCell align="left">
                          {row.height} X {row.width} X {row.thickness}
                        </TableCell>
                        <TableCell align="left">{row.company}</TableCell>
                        <TableCell align="left">{row.quantity}</TableCell>

                        <TableCell align="left">{row.brand}</TableCell>
                        <TableCell align="left">{row.technology}</TableCell>
                        <TableCell align="left">{row.hsn}</TableCell>
                        {viewPermission ? (
                          <TableCell align="center">
                            <VisibilityIcon
                              style={{ color: "green", cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/dashboard/inventory/plateDetails/${row.id}`,
                                  {
                                    state: { id: row.id },
                                  }
                                )
                              }
                            />
                          </TableCell>
                        ) : null}
                        {editPermission ? (
                          <TableCell align="center">
                            <EditIcon
                              style={{ color: "red", cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/dashboard/inventory/update-plate/${row.id}`,
                                  {
                                    state: { id: row.id },
                                  }
                                )
                              }
                            />
                          </TableCell>
                        ) : null}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </StyledTableContainer>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </Paper>
    </div>
  );
}

function GlobalInventory({ auths }) {
  const token = JSON.parse(localStorage.getItem("AuthData"));
  const [loader, setLoader] = useState(true);
  const [editPermission, setEditPermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);

  const [missingPermissions, setMissingPermissions] = useState([]);
  let requiredPermissions = ["view_plate_list"];

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [page, setPage] = React.useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 25
  );

  const [height, setHeight] = React.useState(searchParams.get("height") || "");
  const [width, setWidth] = React.useState(searchParams.get("width") || "");
  const [thickness, setThicknesss] = React.useState(
    searchParams.get("thickness") || ""
  );
  const [onSearch, setOnSearch] = useState(false);
  const [searchKeyword, setSearchKeyWord] = useState(
    searchParams.get("search_keyword") || ""
  );

  const [filter, setFilter] = useState(true);

  const [total, setTotal] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeParams(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    changeParams(0, event.target.value);
  };

  const changeParams = (queryPage, queryLimit) => {
    let query = `?page=${queryPage}&limit=${queryLimit}`;
    let hg = searchParams.get("height");
    let wt = searchParams.get("width");
    let th = searchParams.get("thickness");
    let search = searchParams.get("search_keyword");

    if (hg) {
      query += `&height=${hg}`;
    }
    if (wt) {
      query += `&width=${wt}`;
    }
    if (th) {
      query += `&thickness=${th}`;
    }
    if (search) {
      query += `&search_keyword=${search}`;
    }

    navigate("/dashboard/inventory/global" + query, {
      replace: true,
    });

    getPlates(hg || "", wt || "", th || "", queryPage, queryLimit);
  };

  useEffect(() => {
    if (auths?.user) {
      let userPermissions = auths.user?.role?.permissions;
      if (userPermissions) {
        const missing = _.difference(requiredPermissions, userPermissions);
        setMissingPermissions(missing);
        if (missing.length > 0) {
          swal(
            "",
            `You are unauthorized to complete this action because you do not have the following permissions

            ${_.toUpper(missing.join(", ").replace(/_/g, " "))}
            `,
            "error"
          );
        }
      }
    }
  }, [auths.user]);

  useEffect(() => {
    if (filter || onSearch) {
      navigate(
        `/dashboard/inventory/global?height=${height}&width=${width}&thickness=${thickness}&search_keyword=${searchKeyword}&page=${page}&limit=${rowsPerPage}`,
        {
          replace: true,
        }
      );
      getPlates(height, width, thickness, page, rowsPerPage);
      setFilter(false);
      setOnSearch(false);
    }
  }, [filter, onSearch]);

  useEffect(() => {
    if (token?.type === "super_admin") {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("view_plate_details") ||
      token?.type === "super_admin"
    ) {
      setViewPermission(true);
    }

    if (
      auths?.user?.role?.permissions.includes("download_csv") ||
      token?.type === "super_admin"
    ) {
      setCsvPermission(true);
    }
  }, []);
  const [rows, setRows] = useState([]);

  const getPlates = async (height, width, thickness, page, rowsPerPage) => {
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + token.access_token,
        },
      };
      setLoader(true);

      let url = `/api/v1/${token?.type}/plate_inventory/get_global_inventory`;
      let rows = [];
      url += `?page=${
        page + 1
      }&limit=${rowsPerPage}&height=${height}&width=${width}&thickness=${thickness}&search_keyword=${searchKeyword}`;

      const { data } = await axios.get(url, config);
      const result = data.data.data;

      setTotal(data.data.metadata.total_results);
      result.map((data) => {
        let details = data.plate_data;
        let plate = details.plate;
        rows.push(
          createData(
            details._id,
            details.height,
            details.width,
            details.thickness,
            details.company,
            data.total,
            details.brand.name,
            details.technology.name,
            details.hsn,
            details.height + "X" + details.width + "X" + details.thickness,
            details.is_deleted
          )
        );
        // });
      });

      setRows(rows);
      setLoader(false);
    } catch (e) {
      console.log(e);
    }
    setLoader(false);
  };

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              Global Inventory
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>

              <Typography>Global Inventory</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              rows={rows}
              setRows={setRows}
              viewPermission={viewPermission}
              total={total}
              page={page}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              editPermission={editPermission}
              filter={filter}
              setFilter={setFilter}
              height={height}
              width={width}
              thickness={thickness}
              setHeight={setHeight}
              setWidth={setWidth}
              setThicknesss={setThicknesss}
              searchKeyword={searchKeyword}
              setSearchKeyWord={setSearchKeyWord}
              onSearch={onSearch}
              setOnSearch={setOnSearch}
              csvPermission={csvPermission}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(GlobalInventory);
